import * as React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

type FooterProps = {
  text: string
  link: string
}

const FooterButton = ({ text, link }: FooterProps): JSX.Element => {
  const [textHover, setTextHover] = React.useState(false)

  const textHoverState = useSpring({
    color: textHover ? 'white' : '#AAAAAA',
    textDecoration: textHover ? 'underline' : 'none',
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  return (
    <TextButton
      onMouseEnter={() => setTextHover(true)}
      onMouseLeave={() => setTextHover(false)}
      onClick={() => {
        window.open(link, '_blank')
      }}
      style={textHoverState}
    >
      {text}
    </TextButton>
  )
}

export default FooterButton

const TextButton = styled(animated.div)`
  color: #aaaaaa;
  font-weight: 400;
  cursor: pointer;

  // mobile
  font-size: 12px;

  // tablet+
  @media (min-width: 43em) {
    font-size: 16px;
  }
`
